import { render, staticRenderFns } from "./AMenu.vue?vue&type=template&id=abdb9b78&scoped=true&"
import script from "./AMenu.vue?vue&type=script&lang=js&"
export * from "./AMenu.vue?vue&type=script&lang=js&"
import style0 from "./AMenu.vue?vue&type=style&index=0&id=abdb9b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb9b78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
